import React from "react";

function Team() {
  const team = [
    {
      name: "Ar.Febin Haja",
      role: "Design Principal",
      exp: "25+ years Experience",
    },
    {
      name: "Anbarasi Jambulingam",
      role: "Business Head",
      exp: "45+ years Experience",
      center: true,
    },
    {
      name: "Ar.Ashik Raheem",
      role: "Project Manager",
      exp: "12+ years Experience",
    },
    {
      name: "Ar.Sai Kirthanaa",
      role: "Sr. Architect",
      exp: "6+ years Experience",
    },
    {
      name: "Ar.Amatullah Madhiya",
      role: "Sr. Architect",
      exp: "5+ years Experience",
    },
    {
      name: "Josica Browne David",
      role: "Interior Designer",
      exp: "1+ years Experience",
    },
  ];

  return (
    <section
      style={{
        padding: "80px 20px",
        background: "#f5f5f5",
      }}
    >
      <div
        style={{
          maxWidth: "1100px",
          margin: "0 auto",
          background: "#fff",
          padding: "60px 40px",
        }}
      >
        {/* TITLE */}
        <h2 style={{ textAlign: "center", marginBottom: "15px" }}>
          Meet Our Team
        </h2>

        {/* DESCRIPTION */}
        <p
          style={{
            textAlign: "center",
            maxWidth: "750px",
            margin: "0 auto 60px",
            color: "#666",
            lineHeight: "1.7",
          }}
        >
          Our team brings together over 60+ years of combined experience,
          blending deep industry wisdom with fresh, innovative talent.
          From seasoned professionals in their 60s to dynamic creatives
          in their 20s, we thrive on collaboration and continuous learning.
        </p>

        {/* GRID */}
        <div className="team-grid">
          {team.map((member, i) => (
            <div
              key={i}
              className={`team-item ${member.center ? "center" : ""}`}
            >
              <h3>{member.name}</h3>
              <p className="role">{member.role}</p>
              <p className="exp">{member.exp}</p>
            </div>
          ))}
        </div>
      </div>

      {/* CSS */}
      <style>
        {`
        .team-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 60px 40px;
          align-items: center;
          text-align: center;
        }

        .team-item h3 {
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 6px;
        }

        .role {
          font-size: 14px;
          color: #555;
          margin-bottom: 4px;
        }

        .exp {
          font-size: 13px;
          color: #999;
        }

        /* CENTER PERSON */
        .center {
          transform: scale(1.2);
        }

        .center h3 {
          font-size: 18px;
        }

        /* MOBILE */
        @media (max-width: 768px) {
          .team-grid {
            grid-template-columns: repeat(2, 1fr);
          }

          .center {
            transform: scale(1);
          }
        }

        @media (max-width: 500px) {
          .team-grid {
            grid-template-columns: 1fr;
          }
        }
        `}
      </style>
    </section>
  );
}

export default Team;